import {tgxApi} from "../../../app/tgxApi";
import {getAuthorizationHeader, getFileDownloadHeaders, handleQueryError} from "../../../helpers/utils/RtkQueryUtils";
import {getFileName, serialize} from "../../../helpers/utils/Utils";
import {downloadFile} from "../../../helpers/utils/FileUtils";

export const IncidentsApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({

        searchIncidents: build.query({
            query: (searchParameters) => {
                // Serialize the data to query parameters
                let paramData = serialize(searchParameters);
                return {
                    url: `/incidents/search?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['incidents'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

        exportIncidents: build.query({
            query: (query) => {
                let paramData = serialize(query);

                return {
                    url: `/incidents/export?${paramData}`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("incidents"))
                        return {success: true};
                    },
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

        
    })
})

export const {
    useSearchIncidentsQuery,
    useLazyExportIncidentsQuery,
} = IncidentsApi